import type React from 'react';
import { useMemo } from 'react';

import { createCalendar } from '@internationalized/date';
import type { DateDuration } from '@internationalized/date';

import { useCalendar } from '@react-aria/calendar';
import { useLocale } from '@react-aria/i18n';

import { useCalendarState } from '@react-stately/calendar';

import type { DateValue } from '@react-types/calendar';

import type { CalendarProps } from '../../interface-and-type';
import { CalendarBase } from './controls/calendar-base';

export interface IProps extends CalendarProps<DateValue> {}

export const Calendar: React.FC<IProps> = (props) => {
  const { visibleMonths = 1 } = props;
  const visibleDuration = useMemo<DateDuration>(() => ({ months: visibleMonths }), [visibleMonths]);
  const { locale } = useLocale();
  const state = useCalendarState({
    ...props,
    locale,
    visibleDuration,
    createCalendar
  });

  return <CalendarBase {...props} state={state} useCalendar={useCalendar} />;
};
